"use client";

import { useSyncExternalStore } from "react";

/**
 * 모바일 상단 검색바 오른쪽 필터 버튼 ↔ 검색 페이지 필터 드로어(09-28, 에어비앤비 방식).
 *
 * 필터 드로어의 열림 상태는 검색 페이지(SearchPageClient)가 갖고, 버튼은 레이아웃의
 * Navbar 에 있다 — 서로 부모·자식이 아니라 모듈 스토어로 잇는다. 검색 페이지가 떠 있을
 * 때만 등록되므로 버튼도 그때만 보인다.
 */
interface FilterBridge {
  /** 적용 중인 필터 수(이용 방식·가격) — 0 이면 점을 끈다 */
  active: number;
  open: () => void;
}

let current: FilterBridge | null = null;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

/** 검색 페이지가 마운트·필터 수 변경 시 등록한다. 돌려받은 함수로 해제. */
export function registerSearchFilter(bridge: FilterBridge): () => void {
  current = bridge;
  emit();
  return () => {
    if (current === bridge) {
      current = null;
      emit();
    }
  };
}

export function useSearchFilterBridge(): FilterBridge | null {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => current,
    () => null,
  );
}
